export default __webpack_public_path__ + "static/media/154.1f576e0e.gif";